import { render, staticRenderFns } from "./OnboardingV3BackArrow.vue?vue&type=template&id=63762537&scoped=true&"
import script from "./OnboardingV3BackArrow.vue?vue&type=script&lang=js&"
export * from "./OnboardingV3BackArrow.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingV3BackArrow.vue?vue&type=style&index=0&id=63762537&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63762537",
  null
  
)

export default component.exports